export const streampointTempDocTypes = {
  registration: 'streampointRegistration',
}
